import { EVENTS, NOTIFICATIONS } from "../lib/constants";
import { GameConfigs } from "../lib/globals/GameConfigs";
import HELPERS from "../lib/globals/helpers/Helpers";
import AnimateEntrance from "./helper/animate";

class NotificatitonController {
  constructor(vc, config) {
    this.vc = vc;
    this.configs = config;
    this.msg = "";
    this.vc.notif_bg.close.handler = this.closeHandler.bind(this);
    this.init();
    if (GameConfigs.autospin.isAutoOn) {
      this.stopAutoplay();
    }
    HELPERS.disableAllButtons(true);
    HELPERS.dispatchCustomEvent(EVENTS.NOTIFICATION, { notification: true });
    this.addEventListeners();
  }

  init() {
    this.title = this.vc[this.configs.item].notif_title;
    this.desctiprion = this.vc[this.configs.item].notif_desc;
    this.title.anchor.set(0.5, 0);
    this.desctiprion.anchor.set(0.5, 0);
    this.title.text = NOTIFICATIONS[GameConfigs.notification.code].title;
    this.desctiprion.text = NOTIFICATIONS[GameConfigs.notification.code].desc;
    AnimateEntrance(this.vc);
  }

  stopAutoplay() {
    HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
      numOfBets: GameConfigs.autospin.numOfBets,
      isAutoOn: false,
      leftBets: 0,
      pause: false,
    });
    GameConfigs.autospin.isAutoOn = false;
    GameConfigs.autospin.leftBets = 0;
  }

  handleEvent(evt) {
	const isNotificationModal = GameConfigs.modal === "notification";
	// Function to handle outside click for notification modal
	const handleNotificationClick = (target, x, y) => {
	  if (HELPERS.handleOutsideClick(target, x, y, "notification", true)) {
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		this.closeHandler();
	  }
	};
  
	switch (evt.type) {
	  case EVENTS.INTERACTION:
		const targetBounds = this.vc[this.configs.holder].getBounds();
		if (isNotificationModal) {
		  handleNotificationClick(targetBounds, evt.x, evt.y);
		}
		break;
  
	  case EVENTS.MODAL:
		if (!isNotificationModal) {
		  window.removeEventListener(EVENTS.INTERACTION, this, false);
		  this.closeHandler();
		}
		break;
  
	  default:
		break;
	}
  }

  addEventListeners() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    window.addEventListener(EVENTS.MODAL, this, false);
    this.timeout = setTimeout(() => {
      window.addEventListener(EVENTS.INTERACTION, this, false);
    }, 500);
  }

  removeEvents() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    window.removeEventListener(EVENTS.INTERACTION, this, false);
    window.removeEventListener(EVENTS.MODAL, this, false);
  }

  closeHandler() {
    this.resetError();
    this.removeEvents();
    HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: "" });
  }

  resetError() {
    if (GameConfigs.bonusBuy) {
      GameConfigs.bonusBuy = false;
      HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: false });
    }
    HELPERS.disableAllButtons(false);
    HELPERS.dispatchCustomEvent(EVENTS.NOTIFICATION, { notification: false });
    GameConfigs.notification = {
      code: 0,
      message: "",
      status: "",
    };
  }
}

export default NotificatitonController;
